<template>
    <div class="w-full grid-margin">
        <div v-if="Object.keys(open_sick_leaves).length > 0" class="card mb-4">
            <div class="card-body">
                <div class="card-title">Nieuwe verzuimmeldingen</div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>Medewerker</th>
                            <th>Begin-/einddatum en -tijd</th>
                            <th>Gewerkte uren gemist</th>
                            <th>Verklaring</th>
                            <th class="text-right">Acties</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr :ref="'open' + key" v-for="(value, key) in open_sick_leaves" :key="key">
                            <td>{{ value['profile_name'] }}</td>
                            <td>
                                {{ value['start_time'] }} <b>/</b> {{ value['start_date'] }}
                                <br>
                                <br>
                                {{ value['end_time'] }} <b>/</b> {{ value['end_date'] }}
                            </td>
                            <td><b>{{ value['hours'] }}</b> uur</td>
                            <td>
                                <p class="mb-0 line-height-16 ws-normal mw-300">
                                    {{ value['explanation'] }}
                                </p>
                            </td>
                            <td>
                                <div class="flex justify-end text-gray">
                                    <div @click="judge_sick_leave(key, 2, 'open')" :class="{'text-success': company_demo_not_expired}" class="cursor-pointer mr-3">
                                        <i class="fas fa-check font-size-20 p-1"></i>
                                    </div>
                                    <div @click="judge_sick_leave(key, 1, 'open')" :class="{'text-danger': company_demo_not_expired}" class="cursor-pointer">
                                        <i class="fas fa-times font-size-20 p-1"></i>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <div class="flex justify-between flex-wrap mb-2">
                    <div class="card-title mb-3">Verzuimregistratie</div>
                    <div class="flex flex-wrap">
                        <div class="flex align-items-center mb-3 mr-4">
                            <div class="bg-success mr-2 info-cube"></div>
                            <span>Geaccepteerd</span>
                        </div>
                        <div class="flex align-items-center mb-3">
                            <div class="bg-danger mr-2 info-cube"></div>
                            <span>Afgewezen</span>
                        </div>
                    </div>
                </div>
                <template v-if="Object.keys(all_sick_leaves).length > 0">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>Medewerker</th>
                                <th>Begin-/einddatum en -tijd</th>
                                <th>Gewerkte uren gemist</th>
                                <th>Verklaring</th>
                                <th class="text-right">Acties</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr :ref="key" v-bind:class="{'bg-success' : value['status'] === 2, 'bg-danger' : value['status'] === 1}" v-if="!open_sick_leaves[key]" v-for="(value, key) in all_sick_leaves" :key="key">
                                <td>{{ value['profile_name'] }}</td>
                                <td>
                                    {{ value['start_time'] }} <b>/</b> {{ value['start_date'] }}
                                    <br>
                                    <br>
                                    {{ value['end_time'] }} <b>/</b> {{ value['end_date'] }}
                                </td>
                                <td><b>{{ value['hours'] }}</b> uur</td>
                                <td>
                                    <p class="mb-0 line-height-16 ws-normal mw-300">
                                        {{ value['explanation'] }}
                                    </p>
                                </td>
                                <td>
                                    <div class="flex justify-end text-gray">
                                        <div @click="judge_sick_leave(key, 2, '')" v-bind:class="{'text-success' : value['status'] === 1 && company_demo_not_expired}" class="cursor-pointer mr-3">
                                            <i class="fas fa-check font-size-20 p-1"></i>
                                        </div>
                                        <div @click="judge_sick_leave(key, 1, '')" v-bind:class="{'text-danger' : value['status'] === 2 && company_demo_not_expired}" class="cursor-pointer">
                                            <i class="fas fa-times font-size-20 p-1"></i>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </template>

                <template v-else="">
                    <div class="flex justify-center">
                        <p v-if="Object.keys(open_sick_leaves).length > 0" class="mb-0 font-size-16">
                            Er is nog geen verzuim beoordeeld.
                        </p>
                        <p v-else="" class="mb-0 font-size-16">
                            Er is nog geen verzuim gemeld.
                        </p>
                    </div>
                </template>

            </div>
        </div>
    </div>
</template>


<script>
    export default {
        props: {
            open_sick_leaves: {},
            all_sick_leaves: {},
            company_demo_not_expired: {}
        },
        methods: {
            judge_sick_leave(key, status, origin) {
                if(this.company_demo_not_expired)
                {
                    let ref_key = origin + key;
                    if(status === 1)
                    {
                        this.$refs[ref_key][0].classList = 'bg-danger';
                        this.$refs[ref_key][0].children[4].children[0].children[0].classList.add('text-success');
                        this.$refs[ref_key][0].children[4].children[0].children[1].classList.remove('text-danger');
                    }
                    else
                    {
                        this.$refs[ref_key][0].classList = 'bg-success';
                        this.$refs[ref_key][0].children[4].children[0].children[0].classList.remove('text-success');
                        this.$refs[ref_key][0].children[4].children[0].children[1].classList.add('text-danger');
                    }

                    let axios = require('axios');
                    axios.put('/employer/sick-leaves/' + this.all_sick_leaves[key]['id'], {
                        status: status === 1 ? status : 2

                    });
                }
            }
        }
    }
</script>
